export const WEDDING_DATE = new Date('2025-11-29T19:00:00'); 